export default __webpack_public_path__ + "static/media/lseg.85d68b18.png";